import BaseApi from "./BaseApi";

export default class EmployeeService extends BaseApi {

    constructor(){
        super();
    }

    async list()
    {
        return this.http.get(`${this.baseUrl}/employees`)
        .catch(this.handleErrorResponse);
    }

    async get(id)
    {
        return this.http.get(`${this.baseUrl}/employees/${id}`)
        .catch(this.handleErrorResponse);
    }

    async getWithoutUser()
    {
        return this.http.get(`${this.baseUrl}/employees/gets/no-user`)
        .catch(this.handleErrorResponse);
    }

    async store(data)
    {
        return this.http.post(`${this.baseUrl}/employees`, data)
        .catch(this.handleErrorResponse);
    }

    async update(id, data)
    {
        return this.http.put(`${this.baseUrl}/employees/${id}`, data)
        .catch(this.handleErrorResponse);
    }

    async delete(id)
    {
        return this.http.delete(`${this.baseUrl}/employees/${id}`)
        .catch(this.handleErrorResponse);
    }

}